import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberIncidentresponseteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 29.45a7.58 7.58 0 1 0 0 15.16 7.58 7.58 0 0 0 0-15.16m-9.58 7.58A9.58 9.58 0 0 1 32 27.45a9.58 9.58 0 1 1-9.58 9.58",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M21.148 49.506C23.93 46.34 27.78 44.61 32 44.61s8.07 1.733 10.853 4.9c2.777 3.163 4.447 7.7 4.447 13.26a1 1 0 0 1-1 1H17.7a1 1 0 0 1-1-1c0-5.564 1.67-10.102 4.448-13.264M18.72 61.77h26.56c-.186-4.684-1.683-8.382-3.93-10.94-2.4-2.733-5.7-4.22-9.35-4.22s-6.95 1.485-9.35 4.217c-2.247 2.556-3.744 6.254-3.93 10.943M11.7 36.58a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M2.729 58.58c.18-3.07 1.19-5.48 2.66-7.152C7.01 49.583 9.236 48.58 11.7 48.58c3.141 0 5.91 1.629 7.532 4.608a1 1 0 0 0 1.756-.956c-1.959-3.6-5.389-5.652-9.288-5.652-3.036 0-5.81 1.248-7.814 3.528C1.887 52.383.7 55.63.7 59.58a1 1 0 0 0 1 1h16.21a1 1 0 1 0 0-2zM52.3 36.58a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M52.3 48.58c-3.141 0-5.91 1.629-7.532 4.608a1 1 0 0 1-1.756-.956c1.959-3.6 5.389-5.652 9.288-5.652 3.036 0 5.81 1.248 7.814 3.528 1.999 2.275 3.186 5.522 3.186 9.472a1 1 0 0 1-1 1H46.09a1 1 0 1 1 0-2h15.181c-.18-3.07-1.19-5.48-2.66-7.152-1.621-1.845-3.847-2.848-6.311-2.848M32 1.27a1 1 0 0 1 .882.53l9.02 16.92a1 1 0 0 1-.882 1.47H22.98a1 1 0 0 1-.882-1.47l9.02-16.92A1 1 0 0 1 32 1.27m-7.354 16.92h14.708L32 4.396zM32 8.04a1 1 0 0 1 1 1v3.38a1 1 0 1 1-2 0V9.04a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M32 16.67a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
	]
});
export default SvgCyberIncidentresponseteam;
